import _ from "lodash";
import React, { forwardRef } from "react";
import { connect } from "react-redux";
import {
  getImage,
  typesConfig,
  getIsAllCurriculumSelected,
  homeBasedModulesShortcutMapping,
} from "../Utils";
import classNames from "classnames";
import classes from "./SearchItem.scss";
import { Avatar, useKeyboardShortcutsContext } from "@toddle-edu/ds-web";
import { BoldMatch } from "Utils";
import StudentAlerts from "AppComponents/StudentAlerts";
import { GLOBAL_HEADER_SHORTCUTS_MAPPING } from "Platform/modules/PlatformUtils";
import { ShortcutChip } from "Platform/components/GlobalHeader/components/JumpToFeature/commonComponents";
import { getCurrentCurriculumContextForGlobalSearch } from "modules/CommonSelectors";

export const SearchItem = forwardRef((props, ref) => {
  const {
    item,
    onSelectItem,
    searchText,
    isAllCurriculumSelected,
    index,
    shouldFetchAlertTypes,
  } = props;

  const {
    id,
    title,
    subTitle,
    type,
    imageUrl,
    metadata,
    curriculumIndicatorData,
  } = item;

  let shortcutKey;
  if (homeBasedModulesShortcutMapping[type]) {
    const feature = homeBasedModulesShortcutMapping[type];
    shortcutKey = _.get(
      GLOBAL_HEADER_SHORTCUTS_MAPPING,
      [feature, "shortcutKey"],
      null
    );
  }

  const { areShortcutsEnabled } = useKeyboardShortcutsContext();

  const imageByType = getImage({
    type,
    metadata,
    index,
    curriculumIndicatorData,
  });

  const handleSelectItem = e => {
    e.stopPropagation();
    onSelectItem({ item, e });
  };

  const { id: studentId, alertTypes } = _.get(metadata, "student", {});

  return (
    <div
      data-elm="search-item"
      data-test-id={`globalSearch-searchItem-${id}`}
      className={classes.container}
      role="button"
      tabIndex="-1"
      onClick={handleSelectItem}
    >
      <div className={classes.imageContainerWrapper}>
        {imageByType ? (
          <div className={classes.imageContainer}>{imageByType}</div>
        ) : (
          <Avatar
            size="medium"
            shade="light"
            shape="square"
            name={title}
            src={imageUrl}
            className={classes.profileImageContainer}
          />
        )}
      </div>
      <div className={classes.searchItemLabelContainer} style={{ gap: "2px" }}>
        <div
          className={classNames({
            [classes.title]: true,
            "text-body": true,
          })}
        >
          <div>
            <BoldMatch text={title} match={searchText} />
          </div>
          {type === typesConfig.STUDENT_PROFILE.id ? (
            <StudentAlerts
              studentId={studentId}
              alertTypes={alertTypes}
              shouldFetchAlertTypes={shouldFetchAlertTypes}
            />
          ) : null}
        </div>
        {subTitle || !_.isEmpty(curriculumIndicatorData) ? (
          <div
            className={classNames({
              [classes.subtitle]: true,
              "text-body-s": true,
            })}
          >
            {isAllCurriculumSelected &&
            _.get(curriculumIndicatorData, "acronym") ? (
              <div className={classes.curriculumIndicatorText}>
                {`${_.get(curriculumIndicatorData, "acronym")} ${
                  subTitle === "" || _.isNil(subTitle) ? "" : "/"
                } `}
              </div>
            ) : null}
            <div>
              <BoldMatch text={subTitle} match={searchText} />
            </div>
          </div>
        ) : null}
      </div>
      {shortcutKey && areShortcutsEnabled ? (
        <ShortcutChip shortcutKey={shortcutKey} addJumpToTriggerPrefix={true} />
      ) : null}
    </div>
  );
});
SearchItem.displayName = "SearchItem";

const mapStateToProps = state => {
  const {
    id: currentCurriculumProgramId,
  } = getCurrentCurriculumContextForGlobalSearch(state);

  const isAllCurriculumSelected = getIsAllCurriculumSelected(
    currentCurriculumProgramId
  );

  return {
    isAllCurriculumSelected,
  };
};

export default connect(mapStateToProps, null)(SearchItem);
